import React from "react";
import { Button } from "@mui/material";
import styles from "../../pages/reports-module/patient-survey-report/patient-survey-report.module.scss";

const SurveyReportSatisfactionToggle = ({ mode = "high", onChange }) => {
    const isHigh = mode === "high";
    const isLow = mode === "low";

    return (
        <div className={styles.segmentedToggle}>
            <Button
                disableElevation
                onClick={() => onChange?.("high")}
                className={`${styles.segmentedBtn} ${isHigh ? styles.isActive : ""}`}
            >
                High Satisfaction
            </Button>

            <Button
                disableElevation
                onClick={() => onChange?.("low")}
                className={`${styles.segmentedBtn} ${isLow ? styles.isActive : ""}`}
            >
                Low Satisfaction
            </Button>
        </div>
    );
};

export default SurveyReportSatisfactionToggle;
